import { XDamage, XImpactSize, XOperationType, XWindows } from './const';

export interface BookDamagedGlassV1 {
  date?: string;
  circumstance?: string;
  window: {
    window: XWindows;
    /** Code OEM du vitrage */
    oem?: string;
    /** true si ADAS, sinon false */
    isAdas?: boolean;
  }[];
  type: XDamage;
  impacts?: DamageImpactV1[];
}

export interface DamageImpactV1 {
  size?: XImpactSize;
  /** true si impact dans le champ de vision, sinon false */
  isInViewField?: boolean;
  /** true si impact à moins de 4cm du bord, sinon false*/
  isInEdge?: boolean;
}

export interface BookFreeSlotsWsV1ParamsBase {
  recommendedOperationType: XOperationType;
  /** 1 pour prêt de véhicule, 0 sans */
  share?: 1 | 0;
  damage: BookDamagedGlassV1;
  vehicle: {
    /** Code VIN du véhicule */
    vin?: string;
    /** Immatriculation du véhicule */
    vrn: string;
    /** Marque du véhicule */
    manufacturer?: string;
    /** Modèle du véhicule */
    model?: string;
    /** Année de première mise en service */
    year?: number;
    /** type de vehicule (0: Not set, 1: Private, 2: Company, 3: Lease, 4: Rental) */
    ownerType?: number;
    /** Name of the owning company */
    ownerCompanyName?: string;
  };
  insured: {
    /** Nom de l'assuré */
    lastname: string;
    /** Prénom de l'assuré */
    firstname: string;
    /** Email de l'assuré */
    email: string;
    /** N° de téléphone */
    phoneNumber: string;
    /** Preference de notification */
    preferedNotifcationType?: 'Email' | 'SMS' | 'WhatsApp';
  };
  policyInformation: {
    insuranceChoice: string;
    /** Nom de l'assureur */
    insuranceName: string;
    insuranceCode: string;
    /** N° de contrat de l'assuré */
    policyNumber?: string;
    /** Date de début du contrat */
    insuranceStartDate?: Date;
    /** Date de fin du contrat */
    insuranceEndDate?: Date;
    /** true si l'assuré est couvert BDG, sinon false */
    isCovered?: boolean;
    /** Franchise si remplacement */
    replacementDeductible?: number;
    /** Franchise si réparation */
    repairDeductible?: number;
    /** Taux de franchise si remplacement */
    replacementRateDeductible?: number;
    /** Taux de franchise si réparation */
    repairRateDeductible?: number;
    /** Franchise remplacement minimum */
    minReplacementDeductible?: number;
    /** Franchise remplacement maximum */
    maxReplacementDeductible?: number;
    /** Franchise de réparation minimum */
    minRepairDeductible?: number;
    /** Franchise de réparation maximum */
    maxRepairDeductible?: number;
    /** Plafond franchise remplacement */
    replacementGuaranteeCeiling?: number;
    /** Plafond franchise réparation */
    repairGuaranteeCeiling?: number;
  };
  /** Référence du dossier */
  folderRef: string;
  /** Commentaire */
  comments?: string;
}

export interface BookV1Params {
  mobileServices?: {
    /** Si Pose à Dom demandée */
    address: string;
    postalCode: string;
    city: string;
    comment?: string;
  };
  partnerBranch?: {
    /** N° FCE AXA unique du centre */
    id: string;
    /** Si featureFlip send-partner-branch-address-on-book */
    address?: string;
  };
}

export interface BookFreeSlotsWsV1Params
  extends BookFreeSlotsWsV1ParamsBase,
    BookV1Params {}

export interface BookFreeSlotsWsV1ResponseSuccess {
  status: 'OK';
  response: {
    code: '201';
    message: 'Created';
  };
  request?: any; // Only used to send data to email admin
}

export interface BookFreeSlotsWsV1ResponseError {
  status: string;
  response: {
    code: string;
    message: string;
  };
}

export interface InsuredVehicleDataV1 {
  vrn: string;
  manufacturer: string;
  model: string;
  year?: number;
  ownerType?: number;
  ownerCompanyName?: string;
}
